export default "__VITE_ASSET__BigseIjU__"